import App from "../layouts/app";
import PageTitle from "../components/PageTitle";
import ContentWrapper from "../components/ContentWrapper";
import { useEditor, EditorContent } from '@tiptap/react'
import { FloatingMenu, BubbleMenu } from '@tiptap/react/menus'
import StarterKit from '@tiptap/starter-kit'
import TiptapEditor from "../components/TiptapEditor";


export default function News() {

    const editor = useEditor({
        extensions: [StarterKit], // define your extension array
        content: '<p>Hello World!</p>', // initial content
    })

    return (
        <App>
            <PageTitle title="News" />
            <ContentWrapper>
                <TiptapEditor onChange={() => { }} />
            </ContentWrapper>
        </App >
    )
}